(function () {
    let isMobileView = false;
    let selectedPlanIndex = 2;
    let smallScreenSize = 361;

    function toggleCellVisibility(cell, shouldShow) {
        cell.classList.toggle("hidden", !shouldShow);
        cell.classList.toggle("show", shouldShow);
    }

    function updateTableDisplay(tableWrapper) {
        const table = tableWrapper.firstChild;
        const tableRows = Array.from(table.rows);
        const isSmallScreen = window.innerWidth < smallScreenSize;

        if (isSmallScreen && !isMobileView) {
            tableRows.forEach(row => {
                const featureText = row.cells[0]?.innerHTML || "";

                Array.from(row.cells).forEach((cell, index) => {
                    toggleCellVisibility(cell, index === 1);

                    if (cell.tagName !== "TH" && index !== 0) {
                        const feature = document.createElement("span");
                        feature.classList.add("appended-feature");
                        feature.innerHTML = featureText;
                        cell.prepend(feature);
                    }
                });
            });

            const clonedTable = table.cloneNode(true);
            clonedTable.classList.add("mobile-table-comparison");
            Array.from(clonedTable.rows).forEach(row => {
                Array.from(row.cells).forEach((cell, index) => {
                    toggleCellVisibility(cell, index === selectedPlanIndex);
                });
            });
            tableWrapper.append(clonedTable);
            isMobileView = true;
        } else if (!isSmallScreen && isMobileView) {
            tableWrapper.querySelectorAll(".appended-feature").forEach(el => el.remove());
            tableWrapper.childNodes[1]?.remove();
            tableRows.forEach(row => {
                Array.from(row.cells).forEach((cell, index) => {
                    toggleCellVisibility(cell, index <= 1 || index === selectedPlanIndex);
                });
            });
            isMobileView = false;
        }
    }

    // Compare plans select
    document.querySelectorAll(".compare-plans").forEach(comparePlan => {
        const tableWrapper = document.getElementById(comparePlan.getAttribute("data-table-id"));
        if (!tableWrapper) return;

        updateTableDisplay(tableWrapper);

        comparePlan.addEventListener("change", e => {
            selectedPlanIndex = parseInt(e.target.value) + 1;
            const table = tableWrapper.childNodes[isMobileView ? 1 : 0];

            Array.from(table.rows).forEach(row => {
                Array.from(row.cells).forEach((cell, index) => {
                    toggleCellVisibility(cell, index === selectedPlanIndex || (!isMobileView && index <= 1));
                });
            });
        });

        window.addEventListener("resize", () => updateTableDisplay(tableWrapper));
    });
})();
